<template lang="pug">
    b-row
      b-col(md="4")
      b-col(cols="12" md="4")
        h2 Crear contraseña
        notifications(group="auth" position="top center")

        form(@submit.prevent="createPassword")
          b-form-group(label="Contraseña" label-for="user-password")
            b-form-input.field.form-control(v-model.trim="password" name="password" type="password"
              placeholder="******" id="user-password" v-validate="'required|min:8|verify_password'" ref="password" data-vv-as="contraseña")
            span.danger(v-show="errors.has('password')") {{ errors.first('password') }}
          b-form-group(label="Confirmar contraseña" label-for="user-confirmation-password")
            b-form-input.field.form-control(v-model.trim="password_confirmation" name="password_confirmation" type="password"
              placeholder="******" id="user-confirmation-password" v-validate="'required|confirmed:password'"
              data-vv-as="confirmación contraseña")
            span.danger(v-show="errors.has('password_confirmation')") {{ errors.first('password_confirmation') }}
          .text-center.form-group
              button.btn.btn-default.btn-primary.btn-lg Guardar
</template>

<script>
import kexaApi from '@/services/apiService';
import router from '@/router';

export default {
  name: 'confirm_email',
  data() {
    return {
      password: '',
      password_confirmation: '',
    };
  },
  created() {
    this.$validator.extend('verify_password', {
      getMessage: () => 'La contraseña debe tener al menos: 1 mayúsculas, 1 minúsculas, 1 número, y un caracter especial (, . _ & ? etc)',
      validate: (value) => {
        const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$?_%^&*,.])(?=.{8,})');
        return strongRegex.test(value);
      },
    });
  },
  methods: {
    createPassword() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          const params = {
            uct: this.$route.params.uct,
            rpt: this.$route.query.rpt,
            password: this.password,
            password_confirmation: this.password_confirmation,
          };
          kexaApi.save_password(params)
            .then(() => {
              this.$notify({
                group: 'auth',
                type: 'success',
                title: 'Contraseña creada con éxito',
                duration: 3000,
              });
              setTimeout(() => router.push({ name: 'login' }), 3000);
            }).catch(() => {
              this.$notify({
                group: 'auth',
                type: 'error',
                title: 'Error',
                text: 'Usuario no encontrado',
                duration: 3000,
              });
              setTimeout(() => router.push({ name: 'login' }), 3000);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
  span.danger {
    color: red;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PasswordCreation.vue